var map = {
	"./ei_transfers_icon.svg": 1061,
	"./mainNavigationChevron_icon.svg": 1062,
	"./schedule_icon.svg": 1063,
	"./sports-news_icon.svg": 1064,
	"./sports_icon.svg": 1065,
	"./table_icon.svg": 1066,
	"./transfers_icon.svg": 1067,
	"./worldnews_icon.svg": 1068
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1282;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1282
// module chunks = 15